export enum GiftCardTransactionType {
  Purchase = "Purchase",
  Reload = "Reload"
}

export enum GiftCardTransactionChannel {
  IN_RESTAURANT = "IN_RESTAURANT",
  DIGITAL = "DIGITAL"
}

export type GiftCardDetails = {
  lastFor: string;
  accountIdentifier: string; // usually consider the payment method id used to make a payment
  cardType: 'giftCard'; // Usually used on payment method select to describe card type
  currentBalance: string; // new balance of the user after transfer/merge the balance.
};


export type GiftCardTransferDetails = {
  accountIdentifier: string;
  newBalance: string; // new balance of the user after transfer/merge the balance.
  beginBalance: string; // balance before execute transaction
  transactionId: string; // not really usefull but good for login ;)
};

export type AddGiftCardPayload = {
  giftCardDetails: GiftCardDetails; // Gift Card details
  giftCardTransferDetails: GiftCardTransferDetails;
};

export type AddGiftCardInput = {
  cardNumber: string;
  pin: string;
};

export type UserAccountsResponse = {
  accounts: Array<{
    giftCard: {
      cardType: string;
      currentBalance: number;
      last4: string;
    };
  }>;
};

export type GetGiftCardBalancePayload = {
  currentBalance: number;
};

export type GetGiftCardBalanceInput = {
  token: string;
  pin?: string;
  expiryDate: string;
  isPhysicalCardBalanceCheck?: boolean;
};

export type GetGiftCardDataPayload = {
  giftCardData: {
    cardNumber: string;
    accountIdentifier: string;
    pin?: string;
  };
};

export type GiftCardTransaction = {
  date: string;
  type: GiftCardTransactionType;
  amount: number;
  transactionChannel: GiftCardTransactionChannel;
};

export type GetGiftCardTransactionHistoryPayload = {
  transactions: GiftCardTransaction[];
};
